import React, { useEffect, useState } from 'react'
import SchemaSectionRenderer from '../../components_v1/SchemaSectionRenderer'
import styled from 'styled-components'
import { axios } from 'api'

const WidgetOuter = styled.div`
  display: flex;
  gap: 32px;
  flex-direction: column;
  padding-top: 0;
  padding-bottom: 0;

  .main-flex {
    max-width: 716px;
    margin: 0 4%;
    @media screen and (min-width: 768px) {
      margin: 0;
    }

    @media screen and (min-width: 712px) {
      max-width: none;
    }
  }
`

const BottomWidget = ({ id, type }) => {
  const [schema, setSchema] = useState(null)

  useEffect(() => {
    axios
      .get(`/recommendations/page/${type}/${id}/position/bottom`)
      .then((res) => {
        const bottomSections = res.data?.sections || []
        setSchema((state) => {
          const data = state?.sections || []
          return { sections: [...bottomSections, ...data] }
        })
      })
      .catch((err) => {
        console.log(err)
      })

    axios
      .get(`/recommendations/page/${type}/${id}/position/bottom/merchandised`)
      .then((res) => {
        const merchandisedSections = res.data?.sections || []
        setSchema((state) => {
          const data = state?.sections || []
          return { sections: [...data, ...merchandisedSections] }
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }, [type, id])

  if (!schema) {
    return null
  }

  return (
    <WidgetOuter className='section-container'>
      <SchemaSectionRenderer schema={schema} user={{}} />
    </WidgetOuter>
  )
}

export default BottomWidget
